const TOMBSTONE_TTL_MS = 60_000;

/** session id → expires at (epoch ms) */
const tombstones = new Map<number, number>();

/** Marks a session as ended locally so stale refetches cannot resurrect lockdown. */
export function tombstoneLaborEndedSession(sessionId: number): void {
  if (!Number.isFinite(sessionId) || sessionId <= 0) {
    return;
  }
  tombstones.set(Math.trunc(sessionId), Date.now() + TOMBSTONE_TTL_MS);
}

export function isLaborSessionTombstoned(sessionId: number): boolean {
  if (!Number.isFinite(sessionId) || sessionId <= 0) {
    return false;
  }
  const id = Math.trunc(sessionId);
  const expiresAt = tombstones.get(id);
  if (expiresAt === undefined) {
    return false;
  }
  if (Date.now() > expiresAt) {
    tombstones.delete(id);
    return false;
  }
  return true;
}

export function clearLaborSessionTombstone(sessionId: number): void {
  if (!Number.isFinite(sessionId) || sessionId <= 0) {
    return;
  }
  tombstones.delete(Math.trunc(sessionId));
}

/** Test helper — clears all tombstones. */
export function clearAllLaborSessionTombstones(): void {
  tombstones.clear();
}
